import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { LayoutInitService } from 'src/app/RefModules/_metronic/core';

@Component({
    selector: 'app-pricing-details',
    templateUrl: './pricing-details.component.html',
    styleUrls: ['./pricing-details.component.scss'],
    standalone: false,
})
export class PricingDetailsComponent implements OnInit {
    isUserLoggedIn: boolean;

    constructor(
        private layoutService: LayoutInitService,
        private msalService: MsalService
    ) {
        this.isUserLoggedIn = false;
    }

    ngOnInit(): void {
        this.layoutService.init();
        this.isUserLoggedIn = this.msalService.instance.getActiveAccount() ? true : false;
    }
}
